import { getFileExtension } from '@/util/FileUtil'
import axios from "../../axios";

const state = {
  datapoints: [],
  datapointsQuantity: null,
  detailsObj: null,
  annotationsObj: null,
  datapointsDeletionId: null,
  labelsID: false,
  labelsImage: null,
  studiesFilter: "",
  patientIdFilter: ""
};

const getters = {
  datapoints(state) {
    return state.datapoints;
  },
  getDatapointsQuantity(state) {
    return state.datapointsQuantity;
  },
  detailsObject(state) {
    return state.detailsObj;
  },
  annotationsObject(state) {
    return state.annotationsObj;
  },
  getDatapointsDeletingId(state) {
    return state.datapointsDeletionId;
  },
  getLabelImage(state) {
    return state.labelsImage;
  },
  getStudiesFilter(state) {
    return state.studiesFilter;
  }
};

const mutations = {
  clearDatapoints(state) {
    // reset all
    state.detailsObj = null;
    state.annotationsObj = null;
    state.studiesFilter = "";
    state.patientIdFilter = "";
  },
  storeDatapoints(state, payload) {
    state.datapoints = payload.results;
    state.datapointsQuantity = payload.datapointsCount;
  },
  storeDetails(state, obj) {
    state.detailsObj = obj;
  },
  storeAnnotations(state, obj) {
    state.annotationsObj = obj;
  },
  storeDatapointModalId(state, payload) {
    state.datapointsDeletionId = payload;
  },
	clearLabelImage(state){
		state.labelsID = null;
		state.labelsImage = null;
	},
  storeLabelImage(state, { id, file }) {
    state.labelsID = id
    state.labelsImage = file
  },
  storeStudiesFilter(state, payload) {
    state.studiesFilter = payload;
  },
  storePatientIdFilter(state, payload) {
    state.patientIdFilter = payload;
  }
};

const actions = {
	async fetchDatapoints({ commit, state }, tableData) {
		let encodedQuery = encodeURIComponent(state.studiesFilter)
		console.log(encodedQuery)
		let res = await axios.get(
			`/datapoints/?limit=5&offset=${5 * tableData.page - 5}&search=${ encodedQuery }`
		);

    commit("storeDatapoints", {
      results: res.data.results,
      datapointsCount: res.data.count
    });
  },
  async fetchDetails({ commit, state, dispatch }, id) {
    let res = await axios.get("/datapoints/" + id + "/");

    let details = res.data;

    let res1 = await axios.get(res.data.study);
    details.study = res1.data.name;
    commit("storeDetails", res.data);

    if (state.detailsObj.annotation_set.length > 0) {
      let annotationsArray = [];

      for (let i = 0; i < state.detailsObj.annotation_set.length; i++) {
          let res2 = await axios.get(state.detailsObj.annotation_set[i]);
	  if (["locked"].includes(res2.data.status))
	      continue
          annotationsArray.push(res2.data);
      }
      commit("storeAnnotations", annotationsArray);
      // Select first one with file
      for (let i = 0; i < annotationsArray.length; i++) {
        if (annotationsArray[i].file) {
          await dispatch('showLabelImage', annotationsArray[i].id)
          break
        }
      }
    } else {
      commit("storeAnnotations", null);
    }
  },
  async showLabelImage({ state, commit }, id) {
    const entry = state.annotationsObj.find(item => item.id === id)
    let file = entry.file

    if (getFileExtension(file) === 'json') {
      // Load background image
      const responseImage = await axios.get(state.detailsObj.file, {
        responseType: 'arraybuffer',
        // Deleting Authorization header, because we have one as global Axios
        // config and Google does not play nice with it
        transformRequest: [(data, headers) => {
          delete headers.common.Authorization
          return data
        }]
      })

      const responseJSON = await axios.get(file, {
        // Deleting Authorization header, because we have one as global Axios
        // config and Google does not play nice with it
        transformRequest: [(data, headers) => {
          delete headers.common.Authorization
          return data
        }]
      })

      // Convert background image into image
      const backgroundImage = new Image()

      await new Promise((resolve) => {
        backgroundImage.onload = () => {
          resolve()
        }
        
        backgroundImage.src = URL.createObjectURL(new Blob([new Uint8Array(responseImage.data)]))
      })

      // Create canvas
      const canvas = document.createElement('canvas')
      canvas.width = backgroundImage.width
      canvas.height = backgroundImage.height

      const canvasCtx = canvas.getContext('2d')

      canvasCtx.drawImage(backgroundImage, 0, 0)

      // Draw box annotations
      const json = responseJSON.data

      if (json.images) {        
        let labels = json.images[0] //.find(img => state.detailsObj.file.includes(img.name))

        if (labels) {
          labels = labels.labels
          canvasCtx.lineWidth = 2

          labels.forEach(label => {
            canvasCtx.strokeStyle = label.color

            label.regions.forEach(r => {
              canvasCtx.beginPath()
              canvasCtx.rect(r.x1, r.y1, r.x2 - r.x1, r.y2 - r.y1)
              canvasCtx.stroke()
            })
          }) 
        }
      }

      file = canvas.toDataURL('image/png')      
    } 

    commit('storeLabelImage', { id: entry.id, file })
  },
  deleteLabelImage({ commit }, id) {
      let res = axios.delete(
          `/annotations/${id}`
      ).then((response) => {
		  state.annotationsObj = state.annotationsObj.filter(annotation => {
			  return annotation.id != id
		  })
		  if (state.annotationsObj.length == 0)
			  state.annotationsObj = null
		  commit("clearLabelImage")
	  })
  },
  sendDatapointIdToModal({ commit }, id) {
    commit("storeDatapointModalId", id);
  },
  deleteDatapoint({ dispatch }) {
    const id = state.datapointsDeletionId;

    axios
      .delete("/datapoints/" + id)
      .then(() => {
        dispatch("fetchDatapoints", 1);
        dispatch("sendDatapointIdToModal", null);
      })
      .catch(err => console.log(err));
  },
  setStudiesFilter({ commit }, filter) {
    commit("storeStudiesFilter", filter);
  },
  setPatientIdFilter({ commit }, filter) {
    commit("storePatientIdFilter", filter);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
